import $ from 'jquery';

function MoreCtrl() {
	this.$target     = $('#moreAjax');
	this.$getContent = $('#archiveContent');
	this.$loading = $('.ajax-loading');

	this.get   = this.get.bind(this);
	this.click = this.click.bind(this);

	this.init();
}

MoreCtrl.prototype.init = function() {
	this.$target.on('click', this.click);
}

MoreCtrl.prototype.get = function(path) {
	const self = this;
	$.get(path)
	.done(function(data) {
		let content = $(data).find('#archiveContent');
		let nextLink = $(data).find('#moreAjax');

		self.$loading.removeClass('active');
		self.$getContent.append(content.html());
		self.$target.html(nextLink.html());
	})
}

MoreCtrl.prototype.click = function(e) {
	e.preventDefault();
	this.$loading.addClass('active');
	this.get(this.$target.find('a').attr('href'));
}

export default MoreCtrl;